import {
  useConnectOnboardWalletModalActions,
  useConnectOnboardWalletModalView,
} from '#/features/wallet/modal-connect-onboard-context';
import {
  useWalletActions,
  useWalletView,
} from '#/features/wallet/wallet-context';

import WalletModalConnect from './WalletModalConnect';
import WalletModalOnboard from './WalletModalOnboard';

export default function WalletModalConnectAndOnboard() {
  const modalView = useConnectOnboardWalletModalView();
  const modalActions = useConnectOnboardWalletModalActions();

  const walletView = useWalletView();
  const walletActions = useWalletActions();

  const closeModal = () => {
    if (walletView.status !== 'idle') return;
    walletActions.resetError();
    modalActions.close();
  };

  if (!walletView.isWalletConnected) {
    return (
      <WalletModalConnect isOpen={modalView.isOpen} closeModal={closeModal} />
    );
  }

  return (
    <WalletModalOnboard isOpen={modalView.isOpen} closeModal={closeModal} />
  );
}
